import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-pb-institute-header',
    templateUrl: './pb-institute-header.component.html',
    styleUrls: ['./pb-institute-header.component.scss']
})
export class PbInstituteHeaderComponent implements OnInit {

    @Input() module: any = {};
    @Input() id: any = 0;
    padding_top: any = '';
    padding_bottom: any = '';
    institution: any = {};
    institutionLoaded: boolean = false;
    course: any = {};
    levels: any = 0;
    subjects: any = 0;
    items: any = [];
    localSubjects: any = []; // Comes from our api not catalyst
    subjectsLoaded: boolean = false;
    firstLevelSlug: string = '';

    constructor(
        private api: ApiService,
        private cd: ChangeDetectorRef
    ) { }

    ngOnInit(): void {

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.fetchInstitution();

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

    /**
     * Fetch the institution before fetching the courses
     */
    async fetchInstitution() {

        await this.api.fetch_institution(this.id)
            .subscribe(res => {
                this.institution = res.data.item;
                this.institution.description = JSON.parse(this.institution.description);
                this.institution.short_description = JSON.parse(this.institution.short_description);
                this.institutionLoaded = true;
                this.fetchCourses();
            }, (err) => {
                console.error('Error fetching institution:', err);
            });

    }

    /**
     * Fetch all courses.
     * This data is then passed to parseRawData function which in turn is used to build the sidemenu
     */
    async fetchCourses() {

        await this.api.fetch_course_list()
            .subscribe(res => {
                let index = res.Result?.Course.findIndex(x => x.CourseKey._text == this.id);
                if (index !== -1) {
                    this.course = res.Result?.Course[index];
                }

                // Count number of levels within the course

                let temp = this.ensureArray(this.course.SubjectLevels?.SubjectLevel);
                this.levels = temp.length;

                // Count number of subjects within the course

                this.course.SubjectLevels.SubjectLevel = this.ensureArray(this.course.SubjectLevels?.SubjectLevel);

                this.course.SubjectLevels?.SubjectLevel?.forEach(element => {
                    if (Array.isArray(element.Subjects.Subject)) {
                        this.subjects += element.Subjects.Subject.length;
                    } else {
                        this.subjects++;
                    }
                });

                temp.forEach(level => {
                    let levelIndex = this.institution.levels.findIndex(x => x.identifier == level.SubjectLevelKey._text);
                    if (levelIndex !== -1) {
                        level.SubjectLevelName._text = this.institution.levels[levelIndex].title;
                        level.Priority = this.institution.levels[levelIndex].priority;
                    } else {
                        level.Priority = '';
                    }
                });

                temp.sort(function (a, b) {
                    if (a.Priority < b.Priority)
                        return -1;
                    if (a.Priority > b.Priority)
                        return 1;
                    return 0;
                });

                if (temp.length > 0) {
                    this.firstLevelSlug = this.slugify(temp[0].SubjectLevelName._text);
                }
            }, (err) => {

            });

    }

    /**
     * Slugify a string. Used with the study method name
     * @param str
     * @returns
     */
    slugify(str) {
        str = this.replaceAccents(str);
        str = this.removeNonWord(str);
        str = str.replace(/ +/g, '-') // replace spaces with delimeter
            .toLowerCase();

        return str;
    }

    /**
     * Remove non-word chars.
     */
    removeNonWord(str) {
        return str.replace(/[^0-9a-zA-Z\xC0-\xFF \-]/g, '');
    }

    /**
     * Replaces all accented chars with regular ones
     */
    replaceAccents(str) {
        if (str.search(/[\xC0-\xFF]/g) > -1) {
            str = str
                .replace(/[\xC0-\xC5]/g, 'A')
                .replace(/[\xC6]/g, 'AE')
                .replace(/[\xC7]/g, 'C')
                .replace(/[\xC8-\xCB]/g, 'E')
                .replace(/[\xCC-\xCF]/g, 'I')
                .replace(/[\xD0]/g, 'D')
                .replace(/[\xD1]/g, 'N')
                .replace(/[\xD2-\xD6\xD8]/g, 'O')
                .replace(/[\xD9-\xDC]/g, 'U')
                .replace(/[\xDD]/g, 'Y')
                .replace(/[\xDE]/g, 'P')
                .replace(/[\xE0-\xE5]/g, 'a')
                .replace(/[\xE6]/g, 'ae')
                .replace(/[\xE7]/g, 'c')
                .replace(/[\xE8-\xEB]/g, 'e')
                .replace(/[\xEC-\xEF]/g, 'i')
                .replace(/[\xF1]/g, 'n')
                .replace(/[\xF2-\xF6\xF8]/g, 'o')
                .replace(/[\xF9-\xFC]/g, 'u')
                .replace(/[\xFE]/g, 'p')
                .replace(/[\xFD\xFF]/g, 'y');
        }

        return str;
    }

    /**
     * Helper to make sure that the response is an array
     * @param possibleArray
     * @returns
     */
    ensureArray(possibleArray) {

        if (possibleArray) {
            if (Array.isArray(possibleArray)) {
                return possibleArray;
            } else {
                return [possibleArray];
            }
        } else {
            return [];
        }

    }

}
